import React from 'react';
import styled from 'styled-components';

import { Loyalty as LoyaltyIcon } from 'src/assets/loyalty';
import { DialogHeading } from 'src/components/modals/components/simple-dialog';
import { TextButton } from 'src/components/core';

type PinSuccessLayoutProps = {
  programName: string;
  onClose?: () => void;
  cancelLabel?: string;
  children: React.ReactNode;
};

export const PinSuccessLayout = ({
  programName,
  onClose,
  cancelLabel,
  children,
}: PinSuccessLayoutProps): JSX.Element => (
  <>
    <StyledHeading fontSize={20}>Connect to {programName}</StyledHeading>
    <StyledLoyaltyIcon />
    {children}
    {onClose && cancelLabel && <CancelButton onClick={onClose}>{cancelLabel}</CancelButton>}
  </>
);

const StyledHeading = styled(DialogHeading)`
  margin-bottom: 24px;
`;

const StyledLoyaltyIcon = styled(LoyaltyIcon)`
  margin-bottom: 24px;
`;

const CancelButton = styled(TextButton)`
  /* Matches the var/fallback pair already used by sibling text in
     terms.tsx/pin.tsx/success.tsx for the same secondary ink. */
  color: var(--dcm-modal-secondary-text-color, #646d72);
  font-weight: 600;
  margin-top: 16px;
`;
